/* eslint-disable */
import { loginUser, getInfo, signUpUser } from '@/api/login'
import * as Sentry from '@sentry/browser'

// import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    token: '',
    name: '',
    email: '',
    avatar: '',
    role: '',
    address: '',
    balance: '',
  },
  getters: {
    token: state => state.token,
    avatar: state => state.avatar,
    name: state => state.name,
    email: state => state.email,
    role: state => state.role,
    address: state => state.address,
    balance: state => state.balance
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_EMAIL: (state, email) => {
      state.email = email
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLE: (state, role) => {
      state.role = role
    },
    SET_ADDRESS: (state, address) => {
      state.address = address
    },
    SET_BALANCE: (state, balance) => {
      state.balance = balance
    }
  },

  actions: {
    LoginUser({ dispatch, commit }, userInfo) {
    //  console.log("LoginUser CALLED in USER.js")

      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        loginUser(username, userInfo.password).then(response => {
          const data = response
          // configure sentry scope
          Sentry.configureScope(function (scope) {
            scope.setUser({
              id: data.user.id,
              email: data.user.email
            })
          })

          commit('SET_TOKEN', data.jwt)
          commit('SET_NAME', data.user.username)
          commit('SET_EMAIL', data.user.email)
          commit('SET_BALANCE', data.user.balance)
          commit('SET_AVATAR', `https://ui-avatars.com/api/?name=${data.user.username}`)

          if (data.user.wallet && data.user.wallet.address) {
            commit('SET_ADDRESS', data.user.wallet.address)
          }
         // dispatch('resetChain')
          commit('SET_ROLE', data.user.role.type)
          commit('SET_EMAIL', data.user.email)
    resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    SignUpUser({ dispatch, commit }, userInfo) {
      return new Promise((resolve, reject) => {
        signUpUser(userInfo.email, userInfo.password).then(response => {
          const data = response
          // console.log('data: ', data)
          // setToken(data.jwt)
          if (data.user.confirmed === true) {
            commit('SET_TOKEN', data.jwt)
          }
          commit('SET_NAME', data.user.username)
          if (data.user.wallet && data.user.wallet.address) {
            commit('SET_ADDRESS', data.user.wallet.address)
          }
          // dispatch('resetChain')
          // commit('SET_ROLE', data.user.role.type)
          // commit('SET_EMAIL', data.user.email)
          // commit('SET_AVATAR', `https://ui-avatars.com/api/?name=${data.user.username}`)
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetInfo({ commit, state }) {
    //  console.log("GetInfo CALLED in USER.js")

      return new Promise((resolve, reject) => {
        getInfo(state.token).then(response => {
          const data = response
          commit('SET_BALANCE', data.balance)

          if (data.role && data.role.name) {
            commit('SET_ROLE', data.role.name)
          } else {
            reject('getInfo: role not found !')
          }
          // configure sentry scope
          Sentry.configureScope(function (scope) {
            scope.setUser({
              id: data.id,
              email: data.email
            })
          })
          commit('SET_NAME', data.username)
          commit('SET_EMAIL', data.email)
          commit('SET_AVATAR', `https://ui-avatars.com/api/?name=${data.username}`)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ dispatch, commit, state }) {
      return new Promise((resolve, reject) => {
    //    console.log("LOGOUT CALLED in USER.js")
        commit('SET_TOKEN', '')
        commit('SET_ROLE', '')
        commit('SET_NAME', '')
        commit('SET_EMAIL', '')
        commit('SET_AVATAR', '')
        commit('SET_ADDRESS', '')
        commit('SET_BALANCE', '')

        // TODO: Backlist token at backend - JT
        // removeToken()

        // configure sentry scope
        Sentry.configureScope(scope => scope.setUser(null))

        resolve()
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
    //    console.log("FedLogOut CALLED in USER.js")
        
        commit('SET_TOKEN', '')
        // removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js